(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["color-picker"] && !Shopify.designMode) return;
  try {
    (function() {
  // Store for current selected options per product
  window.madseaSelectedOptions = window.madseaSelectedOptions || {};

  function initColorPicker() {
    const colorPickers = document.querySelectorAll('.madsea-color-picker');

    colorPickers.forEach(picker => {
      const productId = picker.dataset.productId;
      const optionIndex = parseInt(picker.dataset.optionIndex);
      const buttons = picker.querySelectorAll('.madsea-color-picker__btn');
      const selectedSpan = picker.querySelector('.madsea-color-picker__selected');

      // Initialize selected options for this product
      if (!window.madseaSelectedOptions[productId]) {
        window.madseaSelectedOptions[productId] = {};
      }

      // Set initial value from active button
      const activeBtn = picker.querySelector('.madsea-color-picker__btn.is-active');
      if (activeBtn) {
        window.madseaSelectedOptions[productId][optionIndex] = activeBtn.dataset.optionValue;
      }

      buttons.forEach(btn => {
        btn.addEventListener('click', function() {
          if (this.disabled) return;

          const optionValue = this.dataset.optionValue;

          // Update active state
          buttons.forEach(b => b.classList.remove('is-active'));
          this.classList.add('is-active');

          // Update selected text
          if (selectedSpan) {
            selectedSpan.textContent = optionValue;
          }

          // Store selected option
          window.madseaSelectedOptions[productId][optionIndex] = optionValue;

          // Find and update variant
          updateVariant(productId);
        });
      });
    });
  }

  function updateVariant(productId) {
    // Get variants data
    const variantsScript = document.querySelector(`script[data-madsea-variants][data-product-id="${productId}"]`);
    if (!variantsScript) return;

    let variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch(e) {
      console.error('Failed to parse variants', e);
      return;
    }

    // Get all selected options
    const selectedOptions = window.madseaSelectedOptions[productId] || {};

    // Find matching variant
    const matchingVariant = variants.find(variant => {
      return variant.options.every((option, index) => {
        // If we have a selection for this option index, it must match
        if (selectedOptions[index] !== undefined) {
          return option === selectedOptions[index];
        }
        return true;
      });
    });

    if (matchingVariant) {
      // Update all variant ID inputs in forms
      const variantInputs = document.querySelectorAll(`input[name="id"]`);
      variantInputs.forEach(input => {
        input.value = matchingVariant.id;
      });

      // Also update via ref attribute (for product-form-component)
      const refInputs = document.querySelectorAll('[ref="variantId"]');
      refInputs.forEach(input => {
        input.value = matchingVariant.id;
      });

      // Update URL
      const url = new URL(window.location.href);
      url.searchParams.set('variant', matchingVariant.id);
      window.history.replaceState({}, '', url);

      // Dispatch custom event for other components
      document.dispatchEvent(new CustomEvent('madsea:variant:changed', {
        detail: {
          productId: productId,
          variant: matchingVariant
        }
      }));

      // Update buy button availability
      updateBuyButton(matchingVariant);
    }
  }

  function updateBuyButton(variant) {
    const buyBtns = document.querySelectorAll('.madsea-buy__cart-btn');
    buyBtns.forEach(btn => {
      const textEl = btn.querySelector('.madsea-buy__cart-text');
      if (variant.available) {
        btn.disabled = false;
        if (textEl) {
          textEl.textContent = btn.dataset.addText || 'In den Warenkorb';
        }
      } else {
        btn.disabled = true;
        if (textEl) {
          textEl.textContent = btn.dataset.soldText || 'SOLD OUT';
        }
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorPicker);
  } else {
    initColorPicker();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["madsea-buy-buttons"] && !Shopify.designMode) return;
  try {
    (function() {
  const WISHLIST_KEY = 'madsea_wishlist';

  // Wishlist Manager
  const MadseaWishlist = {
    getItems() {
      try {
        return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
      } catch {
        return [];
      }
    },

    saveItems(items) {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
      this.dispatchUpdate(items);
    },

    hasProduct(productId) {
      return this.getItems().some(item => item.id === productId);
    },

    addProduct(product) {
      const items = this.getItems();
      if (!this.hasProduct(product.id)) {
        items.push({
          id: product.id,
          handle: product.handle,
          title: product.title,
          image: product.image,
          price: product.price,
          url: product.url,
          addedAt: Date.now()
        });
        this.saveItems(items);
        return true;
      }
      return false;
    },

    removeProduct(productId) {
      const items = this.getItems().filter(item => item.id !== productId);
      this.saveItems(items);
    },

    toggleProduct(product) {
      if (this.hasProduct(product.id)) {
        this.removeProduct(product.id);
        return false;
      } else {
        this.addProduct(product);
        return true;
      }
    },

    getCount() {
      return this.getItems().length;
    },

    dispatchUpdate(items) {
      window.dispatchEvent(new CustomEvent('madsea:wishlist:updated', {
        detail: { items, count: items.length }
      }));
    }
  };

  // Make globally available
  window.MadseaWishlist = MadseaWishlist;

  // Initialize
  function init() {
    // Update all wishlist buttons state on page load
    updateAllButtons();

    // Handle wishlist button clicks
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-wishlist-btn]');
      if (!btn) return;

      e.preventDefault();

      const product = {
        id: btn.dataset.productId,
        handle: btn.dataset.productHandle,
        title: btn.dataset.productTitle,
        image: btn.dataset.productImage,
        price: btn.dataset.productPrice,
        url: btn.dataset.productUrl
      };

      const isNowSaved = MadseaWishlist.toggleProduct(product);

      // Update button state with animation
      if (isNowSaved) {
        btn.classList.add('is-saved');
        showToast('Auf Merkzettel gespeichert');
      } else {
        btn.classList.remove('is-saved');
        showToast('Vom Merkzettel entfernt');
      }
    });

    // Add loading state on form submit
    document.querySelectorAll('.madsea-buy form').forEach(form => {
      form.addEventListener('submit', function() {
        const btn = this.querySelector('.madsea-buy__cart-btn');
        if (btn && !btn.disabled) {
          btn.classList.add('is-loading');
          setTimeout(() => btn.classList.remove('is-loading'), 2000);
        }
      });
    });
  }

  function updateAllButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const productId = btn.dataset.productId;
      if (MadseaWishlist.hasProduct(productId)) {
        btn.classList.add('is-saved');
      } else {
        btn.classList.remove('is-saved');
      }
    });
  }

  // Toast notification
  function showToast(message) {
    // Remove existing toast
    const existing = document.querySelector('.madsea-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.className = 'madsea-toast';
    toast.innerHTML = `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
      </svg>
      <span>${message}</span>
    `;
    document.body.appendChild(toast);

    // Animate in
    requestAnimationFrame(() => {
      toast.classList.add('is-visible');
    });

    // Auto remove
    setTimeout(() => {
      toast.classList.remove('is-visible');
      setTimeout(() => toast.remove(), 300);
    }, 2500);
  }

  // Listen for updates from other tabs/pages
  window.addEventListener('storage', function(e) {
    if (e.key === WISHLIST_KEY) {
      updateAllButtons();
    }
  });

  // Listen for custom updates
  window.addEventListener('madsea:wishlist:updated', updateAllButtons);

  // Feste Kaufleiste: spiegelt Preis, Groesse und Zustand des echten Kauf-Buttons
  function initSticky(bar) {
    if (bar.dataset.madseaInit) return;
    bar.dataset.madseaInit = '1';
    var buy = bar.parentElement;
    var main = (buy || document).querySelector('.madsea-buy__cart-btn');
    var stickyBtn = bar.querySelector('[data-madsea-sticky-btn]');
    var priceEl = bar.querySelector('[data-madsea-sticky-price]');
    var sizeEl = bar.querySelector('[data-madsea-sticky-size]');
    var headerPrice = document.getElementById('madsea-price-' + bar.dataset.productId);
    if (!main || !stickyBtn) return;

    function sync() {
      stickyBtn.disabled = main.disabled;
      var label = main.querySelector('.madsea-buy__cart-text');
      if (label) stickyBtn.textContent = label.textContent.trim();
      var cur = headerPrice && headerPrice.querySelector('.madsea-price__current');
      if (cur && priceEl) priceEl.textContent = cur.textContent.trim();
      var size = document.querySelector('.madsea-size-picker__selected');
      if (sizeEl) sizeEl.textContent = size ? size.textContent.trim() : '';
    }
    sync();
    new MutationObserver(sync).observe(main, { attributes: true, childList: true, subtree: true, characterData: true });
    if (headerPrice) new MutationObserver(sync).observe(headerPrice, { childList: true, subtree: true, characterData: true });
    document.addEventListener('madsea:variant:changed', function () { setTimeout(sync, 0); });

    stickyBtn.addEventListener('click', function () {
      if (main.disabled) return;
      main.click();
    });

    function setVisible(v) {
      bar.classList.toggle('is-visible', v);
      bar.setAttribute('aria-hidden', v ? 'false' : 'true');
      stickyBtn.tabIndex = v ? 0 : -1;
      document.body.classList.toggle('madsea-sticky-atc-on', v);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          setVisible(!en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }).observe(main);
    }
  }

  // Init on DOM ready
  function boot() {
    init();
    document.querySelectorAll('[data-madsea-sticky-atc]').forEach(initSticky);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["madsea-elbsegler"] && !Shopify.designMode) return;
  try {
    (function() {
  const block = document.querySelector('.madsea-elbsegler');
  if (!block) return;

  // Emblem Klick - wechselt zum Produkt
  block.querySelectorAll('.madsea-elbsegler__emblem').forEach(el => {
    el.addEventListener('click', function() {
      const url = this.dataset.url;
      if (url) {
        window.location.href = url;
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["madsea-product-header"] && !Shopify.designMode) return;
  try {
    (function() {
  // Shopify-Money-Format-Platzhalter; bewusst zusammengesetzt, damit er nicht wie ein Liquid-Tag aussieht
  var DEFAULT_MONEY_FORMAT = '{' + '{amount}' + '} €';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || DEFAULT_MONEY_FORMAT;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || '.';
      decimal = decimal || ',';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function initPriceUpdater() {
    document.addEventListener('madsea:variant:changed', function(e) {
      var productId = e.detail.productId;
      var variant = e.detail.variant;

      var priceContainer = document.getElementById('madsea-price-' + productId);
      var dataScript = document.getElementById('madsea-product-data-' + productId);

      if (!priceContainer || !dataScript) return;

      var data;
      try {
        data = JSON.parse(dataScript.textContent);
      } catch(err) {
        return;
      }

      var moneyFormat = data.money_format || DEFAULT_MONEY_FORMAT;

      // Update price HTML
      var priceHtml = '<span class="madsea-price__current" data-price="' + variant.price + '">' + formatMoney(variant.price, moneyFormat) + '</span>';

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceHtml += '<span class="madsea-price__compare" data-compare-price="' + variant.compare_at_price + '">' + formatMoney(variant.compare_at_price, moneyFormat) + '</span>';
      }

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        if (pct > 0) priceHtml += '<span class="madsea-price__badge">-' + pct + '%</span>';
      }

      priceContainer.innerHTML = priceHtml;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPriceUpdater);
  } else {
    initPriceUpdater();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-picker"] && !Shopify.designMode) return;
  try {
    (function() {
  // Store for current selected options per product
  window.madseaSelectedOptions = window.madseaSelectedOptions || {};

  function initSizePicker() {
    const sizePickers = document.querySelectorAll('.madsea-size-picker');

    sizePickers.forEach(picker => {
      const productId = picker.dataset.productId;
      const optionIndex = parseInt(picker.dataset.optionIndex);
      const buttons = picker.querySelectorAll('.madsea-size-picker__btn');
      const selectedSpan = picker.querySelector('.madsea-size-picker__selected');

      // Initialize selected options for this product
      if (!window.madseaSelectedOptions[productId]) {
        window.madseaSelectedOptions[productId] = {};
      }

      // Set initial value from active button
      const activeBtn = picker.querySelector('.madsea-size-picker__btn.is-active');
      if (activeBtn) {
        window.madseaSelectedOptions[productId][optionIndex] = activeBtn.dataset.optionValue;
      }

      buttons.forEach(btn => {
        btn.addEventListener('click', function() {
          if (this.disabled) return;

          const optionValue = this.dataset.optionValue;

          // Update active state
          buttons.forEach(b => b.classList.remove('is-active'));
          this.classList.add('is-active');

          // Update selected text
          if (selectedSpan) {
            selectedSpan.textContent = optionValue;
          }

          // Store selected option
          window.madseaSelectedOptions[productId][optionIndex] = optionValue;

          // Find and update variant
          updateVariant(productId);
        });
      });
    });
  }

  function updateVariant(productId) {
    // Get variants data
    const variantsScript = document.querySelector(`script[data-madsea-variants][data-product-id="${productId}"]`);
    if (!variantsScript) return;

    let variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch(e) {
      console.error('Failed to parse variants', e);
      return;
    }

    // Get all selected options
    const selectedOptions = window.madseaSelectedOptions[productId] || {};

    // Find matching variant
    const matchingVariant = variants.find(variant => {
      return variant.options.every((option, index) => {
        // If we have a selection for this option index, it must match
        if (selectedOptions[index] !== undefined) {
          return option === selectedOptions[index];
        }
        return true;
      });
    });

    if (matchingVariant) {
      // Update all variant ID inputs in forms
      const variantInputs = document.querySelectorAll(`input[name="id"][value]`);
      variantInputs.forEach(input => {
        // Check if this input belongs to same product
        const form = input.closest('form');
        if (form) {
          const formProductId = form.closest('[data-product-id]');
          if (!formProductId || formProductId.dataset.productId === productId) {
            input.value = matchingVariant.id;
          }
        }
      });

      // Also update via ref attribute (for product-form-component)
      const refInputs = document.querySelectorAll('[ref="variantId"]');
      refInputs.forEach(input => {
        input.value = matchingVariant.id;
      });

      // Update URL
      const url = new URL(window.location.href);
      url.searchParams.set('variant', matchingVariant.id);
      window.history.replaceState({}, '', url);

      // Dispatch custom event for other components
      document.dispatchEvent(new CustomEvent('madsea:variant:changed', {
        detail: {
          productId: productId,
          variant: matchingVariant
        }
      }));

      // Update buy button availability
      updateBuyButton(matchingVariant);
    }
  }

  function updateBuyButton(variant) {
    const buyBtns = document.querySelectorAll('.madsea-buy__cart-btn');
    buyBtns.forEach(btn => {
      const textEl = btn.querySelector('.madsea-buy__cart-text');
      if (variant.available) {
        btn.disabled = false;
        if (textEl) {
          textEl.textContent = btn.dataset.addText || 'In den Warenkorb';
        }
      } else {
        btn.disabled = true;
        if (textEl) {
          textEl.textContent = btn.dataset.soldText || 'SOLD OUT';
        }
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizePicker);
  } else {
    initSizePicker();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
